import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useFlagEnabled } from 'flagging/hooks';
/*
  <FlaggedContent /> handles conditional content depending on if a launchdarkly feature flag is enabled.

  Examples are provided in flagging/README.md
*/
export var FlaggedContent = function (_a) {
    var flag = _a.flag, children = _a.children, _b = _a.enabledContent, enabledContent = _b === void 0 ? children : _b, disabledContent = _a.disabledContent;
    var flagEnabled = useFlagEnabled(flag);
    if (flagEnabled) {
        return enabledContent !== null && enabledContent !== void 0 ? enabledContent : _jsx(_Fragment, {});
    }
    return disabledContent !== null && disabledContent !== void 0 ? disabledContent : _jsx(_Fragment, {});
};
